import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import CartResume from "../components/CartResume";
import ShippingAddress from "../components/ShippingAddress";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import OrderSummary from "../components/OrderSummary";
import PaymentDetails from "../components/PaymentDetails";
import axiosInstance from "../api/axiosConfig";

export default function CheckOut() {
  const [customerData, setCustomerData] = useState(null);
  const customer = useSelector((state) => state.customer);
  const { step } = useParams();
  const navigate = useNavigate();
  const [shipping, setShipping] = useState({});
  const [paymentMethod, setPaymentMethod] = useState([]);

  const sendPaymentMethodToParent = (method) => {
    setPaymentMethod(method);
  };

  const sendShippingDetailsToParent = (detail) => {
    setShipping(detail);
  };

  const getCustomerDetails = async () => {
    const response = await axiosInstance({
      method: "get",
      url: `/customers/${customer.id}`,
      headers: { Authorization: `Bearer ${customer.token}` },
    });

    if (response.status !== 200) return;
    setCustomerData(response.data);
  };

  useEffect(() => {
    if (!customer) navigate("/login");
    getCustomerDetails();
  }, [customer]);

  return (
    <div>
      <Navbar />
      <section className="container mt-5">
        {customer && customerData && (
          <div className="row">
            <div className="col-lg-8">
              {step === "1" && (
                <ShippingAddress
                  customer={customerData}
                  sendShippingDetailsToParent={sendShippingDetailsToParent}
                />
              )}
              {step === "2" && (
                <PaymentDetails sendPaymentMethodToParent={sendPaymentMethodToParent} />
              )}
            </div>
            <div className="col-lg-4 d-flex justify-content-center">
              {step !== "3" && <CartResume />}
            </div>
            <div className="col-lg-12">
              {step === "3" && (
                <OrderSummary
                  shipping={shipping}
                  customerData={customerData}
                  paymentMethod={paymentMethod}
                />
              )}
            </div>
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
}
